// Handle side in device pixels; divided by the zoom level so it stays constant on screen.
export const HANDLE_SIZE_PX = 10;

// Grab area around each handle, larger than the drawn square.
export const HANDLE_HIT_SIZE_PX = 24;

export const HANDLE_STROKE_PX = 1.5;
